import { CandidateListView } from './CandidateListView';

/**
 * Orphan records view (VI-765), rendered at `/orphaned`.
 *
 * Reuses {@link CandidateListView} (same columns + bulk actions) with the
 * `orphanOnly` filter — non-curated candidates with zero linked tenants
 * (`tenant_count = 0`), which are what a reconcile remap leaves behind now that
 * the source candidate is no longer deleted.
 */
export const OrphanedCandidatesView = (): React.JSX.Element => <CandidateListView orphanOnly />;
